import { Service } from '../types';

export const services: Service[] = [
  {
    id: '1',
    title: 'E-Commerce Development',
    description: 'High-converting online stores with seamless checkout experiences',
    outcome: 'Platforms that convert visitors into loyal customers',
    targetAudience: 'Retail brands and direct-to-consumer businesses',
    tech: ['Shopify', 'WooCommerce', 'Magento', 'Custom React/Node.js'],
    cta: 'See E-commerce Examples →'
  },
  {
    id: '2',
    title: 'Custom Software Systems',
    description: 'Tailored solutions for unique business workflows',
    outcome: 'Software that eliminates manual processes and boosts productivity',
    targetAudience: 'Businesses with specific operational needs',
    tech: ['Laravel', 'Node.js', 'Python', 'Angular', 'React'],
    cta: 'View Custom Systems →'
  },
  {
    id: '3',
    title: 'MLM & Network Marketing Platforms',
    description: 'Complete MLM systems with commission tracking and distributor tools',
    outcome: 'Automated operations that scale your network efficiently',
    targetAudience: 'MLM companies and direct selling organizations',
    tech: ['Laravel', 'Vue.js', 'Mobile Apps', 'Real-time Analytics'],
    cta: 'Explore MLM Solutions →'
  },
  {
    id: '4',
    title: 'Blockchain & Crypto Solutions',
    description: 'Secure cryptocurrency platforms and DeFi applications',
    outcome: 'Trustless systems that enable digital asset transactions',
    targetAudience: 'Crypto startups and financial technology companies',
    tech: ['Web3.js', 'Solidity', 'Smart Contracts', 'React'],
    cta: 'See Crypto Projects →'
  },
  {
    id: '5',
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile applications',
    outcome: 'Apps that engage users and drive business growth',
    targetAudience: 'Businesses needing mobile presence',
    tech: ['React Native', 'Flutter', 'iOS', 'Android'],
    cta: 'View Mobile Apps →'
  },
  {
    id: '6',
    title: 'Cybersecurity Services',
    description: 'Comprehensive security assessments and protection systems',
    outcome: 'Secure systems that protect your data and reputation',
    targetAudience: 'Businesses handling sensitive data and transactions',
    tech: ['Penetration Testing', 'Security Audits', 'Compliance', 'Monitoring'],
    cta: 'Learn About Security →'
  }
];
